import { ReactNode } from "react";
import { Link } from "react-router";
import { useShellRootPath } from "../../hooks";
import { Logo as CommonLogo, Tooltip } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { EnvironmentTag } from "../EnvironmentTag";
import styles from "./Logo.module.css";

// TODO: remove logo ID when no longer a required property.

/** The menu bar logo component. */
export const Logo = (): ReactNode => {
  const rootPath = useShellRootPath();

  /** do not change data-testid value below as it will break PDF lambda (capitalrx_pdf_generation),
   * if you plan on changing it, update selectors in PDF lambda as well **/
  return (
    <Tooltip content="Dashboard">
      {(ref) => (
        <Shelf spacing="medium">
          <Link ref={ref} className={`${styles.logoLink} logo`} to={rootPath} data-testid="test__applicationHomeButton" tabIndex={3}>
            <CommonLogo name="judi-white-knockout-horizontal" />
          </Link>
          <EnvironmentTag />
          <Shelf.Spacer />
        </Shelf>
      )}
    </Tooltip>
  );
};
